import { render, staticRenderFns } from "./SerialNumberStatisticsList.vue?vue&type=template&id=6d29079d&scoped=true"
import script from "./SerialNumberStatisticsList.vue?vue&type=script&lang=js"
export * from "./SerialNumberStatisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29079d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d29079d')) {
      api.createRecord('6d29079d', component.options)
    } else {
      api.reload('6d29079d', component.options)
    }
    module.hot.accept("./SerialNumberStatisticsList.vue?vue&type=template&id=6d29079d&scoped=true", function () {
      api.rerender('6d29079d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/serial-number-statistics/SerialNumberStatisticsList.vue"
export default component.exports